import { environment } from '../services/environment'

/**
 custom validators
 **/

export const validator_dependant = (validatorID, {validateString, message}) => {
    try {
        addValidator(validatorID, {
            validateString,
            messages: {en: message},
        })
    } catch (e) {
        console.error(`validator_dependant-${validatorID}-ERROR:`, e)
    }
}

/**
 * When parsley validates a form the existence of parsley-has-{error,success} is in the form otherwise it has not ran yet.
 * @param form_id
 * @returns {boolean}
 */
export const hasFormBeenValidated = (form_id) => {
    if (typeof window == 'undefined' || typeof window.Parsley == 'undefined') {
        return false
    }

    return window.$(`#${form_id}`).find('.parsley-has-error, .parsley-has-success').length > 0
}

export const addValidator = (name, obj) => {
    // error catching
    if (typeof window == 'undefined' || typeof window.Parsley == 'undefined') {
        return false
    }

    // check to see if the validator exists if it does then remove it
    window.Parsley.hasValidator(name) && window.Parsley.removeValidator && window.Parsley.removeValidator(name)

    // create the validator
    window.Parsley.addValidator(name, obj)

    // return the property name of the validator
    return `data-parsley-${name}`
}

export const trigger_custom_validator = (name) => {
    if (typeof window == 'undefined' || typeof window.Parsley == 'undefined') {
        return false
    }

    const selector = `[data-parsley-${name}]`

    // check to see if the validator exists if it does then remove it
    //TODO:: Trigger only the ony validator not all the ones attached to the field.
    window.$(selector).length > 0 &&
    window.$(selector).parsley &&
    window.$(selector).parsley().validate &&
    window.$(selector).parsley().validate(name)
}

export const is_form_valid = (form_name, secondary_condition = true) => {
    if (typeof window == 'undefined') {
        return false
    }
    const valid = window.$(`#${form_name}`).parsley().isValid()

    // in order for validation to fail isValid must be false
    return !(valid === false) && secondary_condition
}

export const reset_field_validation = (field_selector) => {
    try {
        window.$(field_selector).parsley().reset()
    } catch (e) {
    }
}

export const add_custom_error = (field_selector, message_name, message, options = {}) => {
    if (window.$(field_selector).data(message_name) != 1) {
        window.$(field_selector).data(message_name, 1)
        window.$(field_selector).parsley().addError(message_name, {message, ...options})
    }
}

export const remove_custom_error = (field_selector, message_name) => {
    reset_field_validation(field_selector)
    try {
        window.$(field_selector).parsley().removeError(message_name)
        window.$(field_selector).data(message_name, 0)
    } catch (e) {
    }
    manually_validate_field(field_selector)
}

export const manually_validate_field = (field_selector) => {
    reset_field_validation(field_selector)
    try {
        window.$(field_selector).parsley().validate()
    } catch (e) {
    }
}

const errMap = {
    mfa: "Phone has already been verified for another account.",
    dup: "Phone has already been registered."
}

export const validateTime = ({inputName}) => {
    addValidator(inputName, {
        validateString: (val) => {
            const parsedActiveTime = moment(window.$('#active_time').val(), 'HH:mm a')
            const parsedValue = moment(val, 'HH:mm a')

            if (window.$('#expire_date').val() === window.$('#active_date').val() && inputName !== 'activetime') {
                return !moment(parsedValue).isSameOrBefore(parsedActiveTime)
            }

            if (inputName === 'activetime') {
                window.$('#expire_time').parsley().validate()
            }

        },
        messages: {
            en: `Auction end time cannot be before start time`,
        },
    })
}

export const validateTimeInThePast = ({ inputName }) => {
    addValidator(inputName, {
        validateString: (val) => {
            const parsedValue = moment(val, 'HH:mm a')
            const today = moment().format('MM/DD/YYYY')
            const expire_date = moment(window.$('#expire_date').val()).format('MM/DD/YYYY')

            if (today === expire_date) {
                return !moment(parsedValue).isBefore(moment())
            }

        },
        messages: {
            en: `Auction end time cannot be in the past`
        },
    })
}

export const validateActiveDate = ({inputName, auction_status}) => {
    addValidator(inputName, {
        validateString: (val) => {
            const parsedValue = moment(val)
            window.$('#expire_date').parsley().validate()

            if (auction_status !== 'active') {
                return !parsedValue.isBefore(moment().startOf('d'))
            }

        },
        messages: {
            en: "Auction start date cannot be in the past"
        },
    }, )
}


export const validateDate = ({ inputName }) => {
    addValidator(inputName, {
        validateString: (val) => {
            const parsedValue = moment(val)
            const _active_date = window.$('#active_date').val()

            return parsedValue.isSameOrAfter(_active_date)


        },
        messages: {
            en: "Auction end date must occur after start date"
        },
    }, )
}

export const validateDateInThePast = ({ inputName }) => {
    addValidator(inputName, {
        validateString: (val) => {
            const parsedValue = moment(val)

            return !parsedValue.isBefore(moment().startOf('d'))

        },
        messages: {
            en: "Auction end date cannot be in the past"
        },
    })
}

export const date18YearsOrMore = ({ inputName }) => {
    addValidator(inputName, {
        validateString: (val) => {
            const parsedValue = moment(val)

            return parsedValue.isBefore(moment().subtract(18, 'years'))
        },
        messages: {
            en: "You must be older than 18 years old."
        },
    })
}

export const initDupPhoneValidator = (initial, requirePhone, regType) => {

    addValidator('dupphone', {
        validateString: function(val) {
            let def = $.Deferred()
            if (val !== undefined) {
                let _value = val.replace(/\D/g, '')

                if (_value === initial) {
                    return true
                }

                let _prefix = val.match(/\+\d* /g)

                if (_prefix) {
                    _prefix = _prefix[0].replace(/\D/g, '')
                } else {
                    _prefix = ''
                }

                if (_value.slice(_prefix.length).length > 9) {
                    $.ajax(environment.apiEndPoint + 'users/check/phone-exists', {
                        type: 'GET',
                        data: {
                            phone_number: _value.slice(_prefix.length),
                            phone_prefix: _prefix,
                            require_phone: requirePhone,
                            reg_type: regType
                        },
                        headers: { 'x-api-key': environment.apiKey },
                        async: false,
                        success: function (json) {
                            if (json.exists) {
                                def.reject(false)
                            }

                            def.resolve(true)
                        },
                        error: () => {
                            def.reject()
                        },
                    })
                }

                return def.promise()
            }

        },
        messages: {en: errMap[requirePhone ? 'mfa' : 'dup']}
    })
}

export const initValidPhoneValidator = (validator, initial, required) => {

    addValidator(validator, {

        validateString: function (val) {

            if (val !== undefined) {

                let _value = val.replace(/\D/g, '')

                if (!required) {

                    let _match = val.match(/\+\d*/g)

                    if (_match) {

                        let _prefix = _match[0].replace(/\D/g, '')

                        if (_value === _prefix) {
                            return true
                        }
                    }
                }

                if (_value === initial) {
                    return true
                }

                return _value.length > 10
            }

            return false
        },
        messages: { en: 'Please enter a valid phone.' }
    })
}

export const initDupEmailValidator = ({initialValue}) => {
    addValidator('dupemail', {
        validateString: function(val) {
            let def = $.Deferred()

            $.ajax(environment.apiEndPoint + 'users/check/email-exists', {
                type: 'GET',
                data: {
                    email: val,
                },
                headers: { 'x-api-key': environment.apiKey },
                async: false,
                success: function (json) {
                    if (val !== initialValue && json.message === 'true') {
                        def.reject(false)
                    }

                    def.resolve(true)
                },
                error: () => {
                    def.reject()
                },
            })

            return def.promise()
        },
        messages: {en: "Email has already been registered."}

    })
}

export const PasswordValidationPrimary = ({form_id, isValid, password_id = 'password', password_confirm_id = 'password_confirm'}, callback = false) => {
    if (hasFormBeenValidated(form_id)) {

        callback && callback(isValid)

        manually_validate_field(`#${password_id}`)
        manually_validate_field(`#${password_confirm_id}`)
    }
}

export const PasswordValidationSecondary = ({form_id, isValid, password_id = 'password'}) => {
    // secondary validation is handled a special way. the primary validation is done using regex but this one is strictly custom
    if (hasFormBeenValidated(form_id)) {
        remove_custom_error(`#${password_id}`, 'custom-error-message')

        if (!isValid) {
            add_custom_error(`#${password_id}`, 'custom-error-message', 'This field is required. Please check password requirements.', {updateClass: true})
        }
    }
}

export const validateSSNCharacters = () => {
    addValidator('ssnCharacters', {
        validateString: (value) => /^[0-9-]*$/.test(value),
        messages: {
            en: 'Only numbers are allowed.'
        }
    })
}

export const ssnFormatValidator = () => {
    addValidator('ssnFormat', {
        validateString: (value) => {
            if (!/^[0-9-]+$/.test(value)) {
                return true
            }

            return /^\d{3}-\d{2}-\d{4}$/.test(value) || /^\d{9}$/.test(value)
        },
        messages: {
            en: 'Expected input is 9 digits.'
        }
    })
}
